import moment from 'moment-timezone';

export interface FilterValues {
    sortColumn: string;
    sortDirection: 'asc' | 'desc';
    datumVon: string;
    datumBis: string;
    betreuer?: number;
    telBetreuer?: number;
    status?: number;
    berechnungsart: Berechnungsart;
    excludeReclay: boolean;
}

export const defaultFilterValues: FilterValues = {
    sortColumn: 'auNr',
    sortDirection: 'desc',
    datumVon: moment().subtract({ years: 1 }).startOf('year').format('YYYY-MM-DD'),
    datumBis: moment().format('YYYY-MM-DD'),
    betreuer: undefined,
    telBetreuer: undefined,
    status: undefined,
    berechnungsart: 'offen',
    excludeReclay: true,
};

export interface LineData {
    auNr: string;
    status: number;
    datum: string;
    datBis: string;
    kNr: number;
    text: string;
    count: number;
    ekNettoRahmen: number;
    ekNettoAbruf: number;
    ekNettoAbrufP: number;
    ekNettoOffen: number;
    ekNettoOffenP: number;
    vkNettoRahmen: number;
    vkNettoAbruf: number;
    vkNettoAbrufP: number;
    vkNettoOffen: number;
    vkNettoOffenP: number;
    bMargeRahmen: number;
    bMargeAbruf: number;
    bMargeAbrufP: number;
    bMargeOffen: number;
    bMargeOffenP: number;
    anzahlAbrufe: number;
    letzterAbruf: string;
}

export const defaultLineData: LineData = {
    auNr: '',
    status: 0,
    datum: '',
    datBis: '',
    kNr: 0,
    text: '',
    count: 0,
    ekNettoRahmen: 0,
    ekNettoAbruf: 0,
    ekNettoAbrufP: 0,
    ekNettoOffen: 0,
    ekNettoOffenP: 0,
    vkNettoRahmen: 0,
    vkNettoAbruf: 0,
    vkNettoAbrufP: 0,
    vkNettoOffen: 0,
    vkNettoOffenP: 0,
    bMargeRahmen: 0,
    bMargeAbruf: 0,
    bMargeAbrufP: 0,
    bMargeOffen: 0,
    bMargeOffenP: 0,
    anzahlAbrufe: 0,
    letzterAbruf: '',
};

export interface RahmenauftraegeSummary {
    loading: boolean;
    total: LineData;
    lineDataList: LineData[];
    betreuerTotal: { [key: string]: LineData };
    telBetreuerTotal: { [key: string]: LineData };
}

export type Berechnungsart = 'offen' | 'abrufe';
